<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{module}}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{name:'dashboards'}">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item active">{{module}}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row vld-parent">
      <loading :active.sync="isLoading" :is-full-page="false"></loading>
      <div class="col-lg-12">
        <div class="card min-h-350">
          <div class="card-body">
            <div class="media align-items-center d-flex">
              <template v-if="data.usr_photo !== null && data.usr_photo !== ''">
                <img
                  class="rounded-circle details-profile-user mr-3"
                  :src="$root.backEnd+'/'+data.usr_photo"
                  alt="Header Avatar"
                />
              </template>
              <template v-else>
                <img
                  class="rounded-circle details-profile-user mr-3"
                  src="@/assets/images/users.png"
                  alt="Header Avatar"
                />
              </template>
              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-18 mb-1">{{data.usr_fullname}}</h5>
                <p
                  class="text-muted mb-0"
                >Join date : {{ (data.created_at != null) ? $moment(data.created_at).format('HH:mm, DD MMMM YYYY') : ' - '}}</p>
              </div>
            </div>

            <div class="table-responsive mt-4">
              <table class="table table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Email</th>
                    <td>{{ data.usr_email }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Phone Number</th>
                    <td>{{ data.usr_phone }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Alamat</th>
                    <td>{{data.usr_address}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <button type="button" class="btn btn-info" @click="getFields">Edit</button>
          </div>
        </div>
      </div>
    </div>

    <quickCreate
      v-if="childDataLoaded"
      :visible="visible"
      :fields="fields"
      table_module="users"
      :module="module"
      :alias_table="alias_table"
      @hiddenSideSearch="visible = false"
      @fetch="fetchData"
      :defaultValue="{div_id : data.div_id}"
      :uuid="this.data.usr_uuid"
    ></quickCreate>
  </div>
</template>

<script>
import quickCreate from "@/components/quick_create";
export default {
  data() {
    return {
      module: "Profile",
      table_module: "admin",
      alias_table: "usr",
      visible: false,
      isLoading: false,
      data: {},
      childDataLoaded: false
    };
  },
  components: {
    quickCreate
  },
  mounted() {
    if (typeof this.$route.query.page !== 'undefined') 
    {
      this.page = this.$route.query.page
    }
    if (typeof this.$route.query.limit !== 'undefined') 
    {
      this.limit = this.$route.query.limit
    }
    if (typeof this.$route.query.orderBy !== 'undefined') 
    {
      this.orderBy = this.$route.query.orderBy
    }
    if (typeof this.$route.query.sort !== 'undefined') 
    {
      this.sort = this.$route.query.sort
    }
    this.fetchData();
  },
  methods: {
    getFields() {
      this.axios
        .get("/users/edit/" + this.data.usr_uuid).then(response => {
          this.fields = response.data.data;
          this.childDataLoaded = true;
          this.visible = true;
        });
    },
    fetchData() {
      this.isLoading = true;
      this.axios
        .get("users/detail")
        .then(response => {
          this.data = response.data.data;
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          if (error.response) {
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    }
  }
};
</script>